import { CofStatus, NewApplicationStatus } from '../../../hoc/customers/types';

import cn from './overview.module.css';

export const getCofStatus = (status: CofStatus) => {
  let cofStatus: string;
  let cofStatusClassName = cn.cofDefault;

  switch (status) {
    case CofStatus.APPROVED:
      cofStatus = 'Approved';
      cofStatusClassName = cn.cofApproved;
      break;
    case CofStatus.ARCHIVED:
      cofStatus = 'Archived';
      cofStatusClassName = cn.cofArchived;
      break;
    case CofStatus.REJECTED:
      cofStatus = 'Rejected';
      cofStatusClassName = cn.cofRejeted;
      break;
    case CofStatus.PENDING_REVIEW:
      cofStatus = 'Pending review';
      break;
    default:
      cofStatus = status;
      break;
  }

  return { cofStatus, cofStatusClassName };
};

export const getCofApplicationStatus = (status: NewApplicationStatus) => {
  let applicationStatus: string;
  let applicationStatusClassName = cn.cofDefault;

  switch (status) {
    case NewApplicationStatus.ACCEPTED:
      applicationStatus = 'Accepted';
      applicationStatusClassName = cn.cofApproved;
      break;
    case NewApplicationStatus.DECLINED:
      applicationStatus = 'Declined';
      applicationStatusClassName = cn.cofRejeted;
      break;
    case NewApplicationStatus.INCOMPLETE:
      applicationStatus = 'Incomplete';
      break;
    case NewApplicationStatus.READY_TO_REVIEW:
      applicationStatus = 'Ready to Review';
      applicationStatusClassName = cn.cofReadyToReview;
      break;
    case NewApplicationStatus.REVIEW_IN_PROGRESS:
      applicationStatus = 'Review in Progress';
      applicationStatusClassName = cn.cofReadyToReview;
      break;
    default:
      applicationStatus = status;
      break;
  }

  return { applicationStatus, applicationStatusClassName };
};
